import React from 'react';
import { Helmet } from 'react-helmet';
import NewsletterL1 from '../../../Componet/Newsletter/NewsletterL1';
import HerosectionHeader from '../../../Componet/Herosection/HerosectionHeader';
import DISASTER1 from '../../../Componet/Disaster/DISASTER1He';
import ConsultingForm from '../../../Componet/Consulting/ConsultingForm';

const MEETING_URL = 'https://meetings.hubspot.com/viacheslav-seifer';

function DisasterHe() {
    return (
        <div className="disaster-recovery-page-rtl" dir="rtl">
            <Helmet>
                <title>EpicFinal - התאוששות קריסה וגיבוי (DR) לעסקים</title>
                <meta
                    name="description"
                    content="פתרונות DR וגיבוי לעסקים שצריכים לצמצם השבתות, להגן על מידע קריטי, ולבנות יכולת התאוששות והמשכיות עסקית שאפשר לסמוך עליה."
                />
                <meta
                    name="keywords"
                    content="התאוששות קריסה, DR, גיבוי ענן, גיבוי מרוחק, המשכיות עסקית, שחזור מידע, disaster recovery, ransomware recovery"
                />
                <meta property="og:title" content="EpicFinal - התאוששות קריסה וגיבוי (DR) לעסקים" />
                <meta
                    property="og:description"
                    content="פתרונות DR וגיבוי לעסקים שצריכים לצמצם השבתות, להגן על מידע קריטי, ולבנות יכולת התאוששות והמשכיות עסקית שאפשר לסמוך עליה."
                />
                <meta property="og:type" content="website" />
                <meta property="og:url" content="https://epicfinal.com/he/disaster_recovery" />
                <meta property="og:locale" content="he_IL" />
                <meta property="og:site_name" content="EpicFinal" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:title" content="EpicFinal - התאוששות קריסה וגיבוי (DR) לעסקים" />
                <meta
                    name="twitter:description"
                    content="פתרונות DR וגיבוי לעסקים שצריכים לצמצם השבתות, להגן על מידע קריטי, ולבנות יכולת התאוששות והמשכיות עסקית שאפשר לסמוך עליה."
                />
            </Helmet>
            <HerosectionHeader folder1={"pages"} folder2={"Solutions"} name={"התאוששות קריסה וגיבוי (DR)"} />
            <div className="page-content">
                <DISASTER1 />
                <ConsultingForm
                    language="he"
                    formId="epic-disaster-form"
                    conversionSendTo="AW-11461100984/kH7TCOSNtZgcELiLitkq"
                    conversionValue={1.0}
                    requireHubspotCookie={true}
                    meetingUrl={MEETING_URL}
                    title="ספרו לנו מה אתם צריכים לגבות ולהגן"
                    subtitle="השאירו פרטים קצרים ונחזור אליכם עם מענה מקצועי והכוונה ראשונית לגיבוי ולהתאוששות שלכם."
                />
                <NewsletterL1 />
            </div>
        </div>
    );
}

export default DisasterHe;

